export default {
  namespaced: true,
  state: {
    model: {
      id: null,
      countryOfBirth: '',
      identification: '',
      firstNames: '',
      lastName: '',
      bornAt: null,
      gender: null,
      biography: null,
      mobileNumber: '',
      driversLicense: null,
      errors: {},
    },
    loading: false,
  },
  getters: {
    model: state => state.model,
    loading: state => state.loading,
  },
  mutations: {
    set(state, profile) {
      state.model = { errors: {}, ...profile }
    },
    setLoading(state, loadingState) {
      state.loading = loadingState
    },
  },
  actions: {
    fetch({ commit }) {
      commit('setLoading', true)
      return Vue.$http
        .get('candidate/profile')
        .then(response => {
          commit('set', response.data)
          commit('setLoading', false)
          return response.data
        })
        .catch(error => null)
    },

    refreshCompletion({ commit }, id) {
      return Vue.$http
        .get(`candidate/profile/completion`)
        .then(response => commit('set', response.data))
    },

    update({ commit, getters, dispatch }, profile) {
      commit('setLoading', true)
      return Vue.$http
        .patch('candidate/profile', { profile })
        .then(
          response => commit('set', { ...getters['model'], errors: {}, ...profile }),
          error => {
            if (error && error.response && error.response.data && error.response.data.errors) {
              const errors = error.response.data.errors
              commit('set', { ...getters['model'], errors })
            }
            throw error
          }
        )
        .then(() => dispatch('auth/refresh', null, { root: true }))
        .then(() => commit('setLoading', false))
    },
  },
}
